module.exports = __webpack_public_path__ + "img/system.c7bb52f3.png";